<script setup lang="ts">
const appConfig = useAppConfig();
const {t} = useI18n()
</script>

<template>
  <div class="car-invoice-v2__header">
    <div class="car-invoice-v2__header-left">
      <span class="text">{{ t('pdf.company5.title') }}</span>
      <img
        :src="appConfig?.appearance?.logo"
        alt="AutoGeorgia"
        class="logo"
      >
    </div>
    <div class="car-invoice-v2__header-right">
      <div class="list">
        <span class="car-list-item bold">{{ t('pdf.labels.shipping') }}</span>
        <span class="car-list-item">{{ t('pdf.company5.address_1') }}</span>
        <span class="car-list-item">{{ t('pdf.company5.address_2') }}</span>
        <span class="car-list-item">{{ t('pdf.company5.tel') }}</span>
        <a
          href="mailto:gudadzeamirani@gmail.com"
          class="car-list-item link"
        >gudadzeamirani@gmail.com</a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.car-invoice-v2__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #000;

  &-left {
    display: flex;
    flex-direction: column;

    .text {
      display: block;
      font-size: 8px;
      margin-bottom: 5px;
    }

    .logo {
      width: 165px;
      height: 40px;
    }
  }

  &-right {
    .list {
      display: flex;
      flex-direction: column;

      &-item {
        font-size: 8px;
        text-align: right;
        margin-bottom: 3px;

        &.bold {
          font-weight: 700;
        }

        &.link {
          text-decoration: underline;
          color: #000;
        }
      }
    }
  }
}
</style>
